import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    Proceso: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const GET_ALL_PROCESOS = 'GET_ALL_PROCESOS'
const GET_PROCESO_BY_ID = 'GET_PROCESO_BY_ID'
const GET_PROCESO_BY_ID_TIPO_AREA = 'GET_PROCESO_BY_ID_TIPO_AREA'
const POST_PROCESO = 'POST_PROCESO'
const UPDATE_PROCESO = 'UPDATE_PROCESO'
const DELETE_PROCESO = 'DELETE_PROCESO'
//*******************************************************************************************************************


//MÉTODOS 
export const getAllProcesos = createAsyncThunk(
    GET_ALL_PROCESOS,
    async () => {
        try {
            const fullUrl = host + `Procesos/obtenerPreguntasInstalacion`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen las Procesos: '+JSON.stringify(res.data))
            return res
        } catch (error) {
            console.log(error.res);
        }
    }
)

export const getProcesoById = createAsyncThunk(
    GET_PROCESO_BY_ID,
    async (idProceso) => {
        try {
            const fullUrl = host + `Procesos/obtenerProcesoById/${idProceso}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const getProcesoByIdArea = createAsyncThunk(
    GET_PROCESO_BY_ID_TIPO_AREA,
    async (idTipoInstalacion) => {
        try {
            const fullUrl = host + `Procesos/obtenerProcesoByIdArea/${idTipoInstalacion}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertProceso = createAsyncThunk(
    POST_PROCESO,
    async (data) => {
        try {
            const fullUrl = host + `Procesos/agregarProceso`
            //alert(JSON.stringify(data))
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const updateProceso = createAsyncThunk(
    UPDATE_PROCESO,
    async (data) => {
        try {
            const fullUrl = host + `Procesos/actualizarProceso`
            //alert(JSON.stringify(data))
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const deleteProceso = createAsyncThunk(
    DELETE_PROCESO,
    async (idProceso) => {
        try {
            const fullUrl = host + `Procesos/eliminarProceso/${idProceso}`
            const result = await axios.delete(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosProcesoSlice = createSlice({

    name: 'metodosProcesoSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {

        [getAllProcesos.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD VEHICULOS'+JSON.stringify(payload))
            state.Proceso = payload.data.data

        },
        [getProcesoById.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.Proceso = payload.data.data
        },
        [getProcesoByIdArea.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.Proceso = payload.data.data
        },
        [insertProceso.fulfilled]: (state, { payload }) => {
            state.Proceso = payload.data.data
        },

        [updateProceso.fulfilled]: (state, { payload }) => {

        },
        [deleteProceso.fulfilled]: (state, { payload }) => {

        },

    },

})


export const { } = metodosProcesoSlice.actions
export const ProcesoReducer = metodosProcesoSlice.reducer